{
  "name": "@smarthead/frontend-monorepo",
  "description": "SmartHead Frontend Monorepo",
  "version": "3.101.0",
  "license": "MIT",
  "private": true,
  "contributors": [
    {
      "name": "Martin Duris",
      "email": "martin.duris@besmarthead.com"
    },
    {
      "name": "Martin Havala",
      "email": "martin.havala@besmarthead.com"
    },
    {
      "name": "Adam Kobyda",
      "email": "adam.kobyda@besmarthead.com"
    },
    {
      "name": "Pavol Krajci",
      "email": "pavol.krajci@besmarthead.com"
    },
    {
      "name": "Martin Ockovsky",
      "email": "martin.ockovsky@besmarthead.com"
    },
    {
      "name": "Andrej Pokoraczki",
      "email": "andrej.pokoraczki@besmarthead.com"
    },
    {
      "name": "Jakub Smetanka",
      "email": "jakub.smetanka@besmarthead.com"
    },
    {
      "name": "Patrik Urda",
      "email": "patrik.urda@besmarthead.com"
    },
    {
      "name": "Marek Zavacky",
      "email": "marek.zavacky@besmarthead.com"
    }
  ],
  "engines": {
    "npm": "11.2.0",
    "node": "v22.14.0"
  },
  "packageManager": "npm@11.2.0",
  "repository": {
    "type": "git",
    "url": "https://bitbucket.org/smartheadteam/smarthead-frontend-applications-monorepo"
  },
  "scripts": {
    "prepare": "husky || true",
    "postinstall": "rimraf .angular && npm run openapi:build:all && npm run ui-icons:build:prod && npm run ui-platform:build:prod",
    "update": "ncu --interactive --format group --root",
    "ng": "ng",
    "ngxs": "ngxs",
    "build": "openapi:build:all && ng build",
    "build:stats": "ng build --project client --named-chunks --stats-json --configuration development",
    "build:stats-prod": "ng build --project client --named-chunks --stats-json",
    "analyze": "vite-bundle-visualizer -i ./dist/client/index.html",
    "analyze:es": "esbuild-visualizer --metadata ./dist/client/stats.json  --filename --open",
    "lint:ls": "ls-lint",
    "lint:pkg": "npmPkgJsonLint ./package.json",
    "lint:lf": "lockfile-lint --path package-lock.json",
    "lint:md": "markdownlint **/**.md --ignore node_modules",
    "lint:md:fix": "markdownlint **/**.md --ignore node_modules --fix",
    "lint:html": "htmlhint \"projects/**/src/**/*.html\"",
    "lint:style": "stylelint projects/**/**.scss",
    "lint:style:fix": "stylelint projects/**/**.scss --fix",
    "lint:ts": "ng lint",
    "lint:ts:fix": "ng lint --fix",
    "lint": "run-p --print-label lint:ls lint:pkg lint:lf lint:html lint:md lint:style lint:ts",
    "lint:fix": "run-p --print-label lint:ls lint:pkg lint:lf lint:html lint:md:fix lint:style:fix lint:ts:fix",
    "format:check": "prettier --check \"**/*.{cjs,html,less,md,mjs,scss,ts,yaml,yml}\"",
    "format:fix": "prettier --write \"**/*.{cjs,html,less,md,mjs,scss,ts,yaml,yml}\"",
    "i18n:full": "npm run i18n:extract-remove && npm run i18n:upload && npm run i18n:download",
    "i18n:download": "node scripts/i18n-download.mjs",
    "i18n:upload": "node scripts/i18n-download.mjs --upload",
    "i18n:extract": "transloco-keys-manager extract --project client --sort",
    "i18n:extract-remove": "transloco-keys-manager extract --project client --sort --remove-extra-keys -i projects/client/src/app/profile/profile-esg-management/profile-esg-eu-taxonomy-page,projects/client/src/app/profile/profile-eu-taxonomy",
    "i18n:extract-debug": "DEBUG=* transloco-keys-manager extract --project client --sort -i projects/client/src/app/profile/profile-esg-management/profile-esg-eu-taxonomy-page,projects/client/src/app/profile/profile-eu-taxonomy",
    "i18n:find": "transloco-keys-manager find --project client -i projects/client/src/app/profile/profile-esg-management/profile-esg-eu-taxonomy-page",
    "i18n:find-custom": "DEBUG=* transloco-keys-manager find --project client -i projects/client/src/app/profile/profile-esg-management/profile-esg-eu-taxonomy-page",
    "test-ci": "npm run client:test-ci && npm run client:e2e-ci",
    "prestart:client": "npm run pre-build-fixes",
    "start:client": "ng serve --project client",
    "test:client": "jest --projects projects/client  --config projects/client/jest.config.ts --coverage",
    "test:client:watch": "jest --projects projects/client --config projects/client/jest.config.ts --watch",
    "storybook:client": "ng run client:storybook",
    "start:admin": "ng serve --project admin",
    "start:design-guideline": "ng serve --project design-guideline",
    "start:ui-icons": "ng build --project ui-icons --watch",
    "start:ui-platform": "ng build --project ui-platform --watch",
    "all:build:test": "npm run openapi:build:all && npm run ui-icons:build:prod && npm run ui-platform:build:prod && npm run client:build:test && npm run admin:build:test",
    "all:build:prod": "npm run openapi:build:all && npm run ui-icons:build:prod && npm run ui-platform:build:prod && npm run client:build:prod && npm run admin:build:prod",
    "client:build:test": "npm run pre-build-fixes && ng build --project client --configuration test && npm run post-build-fixes",
    "client:build:prod": "npm run pre-build-fixes && ng build --project client && npm run post-build-fixes",
    "pre-build-fixes": "npm run tool:configs-generator",
    "post-build-fixes": "npm run tool:sw-fix && npm run tool:version-file",
    "client:source-maps": "ng build --project client --build-optimizer --source-map",
    "client:e2e": "ng e2e",
    "ui-icons:build:prod": "ng build --project ui-icons",
    "ui-platform:build:prod": "ng build --project ui-platform",
    "cy:local": "cypress open --env fileConfig=local --browser chrome",
    "cy:local-run": "cypress run --env fileConfig=local --browser chrome",
    "cy:test": "cypress run --env fileConfig=development --browser chrome",
    "cy:test-dashboard": "cypress run --env fileConfig=development --browser chrome --record --key 0dca4055-9fdb-4260-9024-c148a4075950",
    "cy:local-test": "cypress open --env fileConfig=development --browser chrome",
    "cy:prod": "cypress run --env grepTags=@prodTest,grepFilterSpecs=true,fileConfig=production --browser chrome",
    "cy:prod-test": "cypress open --env fileConfig=production --browser chrome",
    "client:e2e-ci": "env HEADLESS=true ng e2e",
    "client:e2e-sl": "ng e2e --project client --port 4201 --host=client.local --protractor-config=e2e/client/protractor-sauce-labs.conf.js",
    "admin:build:test": "ng build --project admin --configuration test",
    "admin:build:prod": "ng build --project admin",
    "admin:source-maps": "ng build --project admin --build-optimizer --source-map",
    "design-guideline:build": "ng build --project design-guideline",
    "openapi:build:all": "npm run openapi:build:download && npm run openapi:build:analytics && npm run openapi:build:audit-log && npm run openapi:build:smarthead && npm run openapi:build:auth0 && npm run openapi:build:client-statistics && npm run openapi:build:prediction && npm run openapi:build:link-shortener && npm run openapi:build:mail && npm run openapi:build:purchase && npm run openapi:build:user-rank && npm run openapi:build:esg && npm run openapi:build:pdf-generator",
    "openapi:build:download": "ts-node --project scripts/tsconfig.json scripts/download-openapi-files.ts",
    "openapi:build:analytics": "ng-openapi-gen --input AppDir/analytics-api/openapi-doc.yaml --output projects/api/analytics-api/",
    "openapi:build:audit-log": "ng-openapi-gen --input AppDir/audit-log-api/openapi-doc.yaml --output projects/api/audit-log/",
    "openapi:build:smarthead": "ng-openapi-gen --config AppDir/smarthead-api/open-api.config.json",
    "openapi:build:client-statistics": "ng-openapi-gen --input AppDir/client-statistics-api/openapi-doc.yaml --output projects/api/client-statistics-api/",
    "openapi:build:prediction": "ng-openapi-gen --input AppDir/prediction-api/openapi-doc.yaml --output projects/api/prediction-api/",
    "openapi:build:mail": "ng-openapi-gen --config AppDir/mail-api/open-api.config.json",
    "openapi:build:link-shortener": "ng-openapi-gen --input AppDir/link-shortener-api/openapi-doc.yaml --output projects/api/link-shortener-api/",
    "openapi:build:purchase": "ng-openapi-gen --input AppDir/purchase-api/openapi-doc.yaml --output projects/api/purchase-api/",
    "openapi:build:auth0": "ng-openapi-gen --input AppDir/auth0-api/openapi-doc.yaml --output projects/api/auth0-api/",
    "openapi:build:user-rank": "ng-openapi-gen --input AppDir/user-rank-api/openapi-doc.yaml --output projects/api/user-rank-api/",
    "openapi:build:esg": "ng-openapi-gen --input AppDir/esg-api/openapi-doc.yaml --output projects/api/esg-api/",
    "openapi:build:pdf-generator": "ng-openapi-gen --input AppDir/pdf-generator-api/openapi-doc.yaml --output projects/api/pdf-generator-api/",
    "svgo": "svgo --folder projects --recursive",
    "pre-commit": "lint-staged",
    "release": "standard-version",
    "release:next-version": "next-standard-version",
    "tool:sw-fix": "node scripts/sw-fix.mjs",
    "tool:version-file": "node scripts/version-file.mjs",
    "tool:configs-generator": "node scripts/configs-generator.mjs"
  },
  "dependencies": {
    "@angular/animations": "19.2.2",
    "@angular/cdk": "16.2.14",
    "@angular/common": "19.2.2",
    "@angular/compiler": "19.2.2",
    "@angular/core": "19.2.2",
    "@angular/forms": "19.2.2",
    "@angular/google-maps": "19.2.3",
    "@angular/material": "16.2.14",
    "@angular/platform-browser": "19.2.2",
    "@angular/platform-browser-dynamic": "19.2.2",
    "@angular/router": "19.2.2",
    "@angular/service-worker": "19.2.2",
    "@angular/youtube-player": "19.2.3",
    "@auth0/angular-jwt": "5.2.0",
    "@auth0/auth0-angular": "2.2.3",
    "@ctrl/tinycolor": "4.1.0",
    "@digitalascetic/ngx-pica": "14.0.0",
    "@elastic/apm-rum": "5.16.3",
    "@jest/globals": "30.0.0-beta.3",
    "@jsverse/transloco": "7.5.1",
    "@ngx-formly/core": "7.0.1",
    "@ngxs/store": "19.0.0",
    "@sentry/angular": "9.5.0",
    "angular-froala-wysiwyg": "4.5.0",
    "big.js": "6.2.2",
    "blob-util": "2.0.2",
    "bootstrap": "4.6.2",
    "chart.js": "4.4.8",
    "chartjs-plugin-annotation": "3.1.0",
    "chartjs-plugin-datalabels": "2.2.0",
    "convert-units": "3.0.0-beta.5",
    "dayjs": "1.11.13",
    "deepmerge": "4.3.1",
    "diff-match-patch": "1.0.5",
    "docx": "9.2.0",
    "echarts": "5.6.0",
    "exifr": "7.1.3",
    "file-saver": "2.0.5",
    "froala-editor": "4.5.0",
    "html2canvas": "1.4.1",
    "intersection-observer": "0.12.2",
    "intro.js": "7.2.0",
    "jwt-decode": "4.0.0",
    "lodash": "4.17.21",
    "ng-lazyload-image": "9.1.3",
    "ng-zorro-antd": "16.2.2",
    "ng2-charts": "8.0.0",
    "ngx-cookie-service": "19.1.2",
    "ngx-drag-scroll": "18.0.0",
    "ngx-mask": "19.0.6",
    "ngx-pipes": "3.2.2",
    "pica": "9.0.1",
    "rxjs": "7.8.2",
    "tslib": "2.8.1",
    "uuid": "11.1.0",
    "xlsx-js-style": "1.2.0",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.2.4",
    "@angular/build": "19.2.3",
    "@angular/cli": "19.2.3",
    "@angular/compiler-cli": "19.2.2",
    "@angular/language-service": "19.2.2",
    "@chromatic-com/storybook": "3.2.6",
    "@commitlint/cli": "19.8.0",
    "@commitlint/config-conventional": "19.8.0",
    "@jsverse/transloco-keys-manager": "6.1.0",
    "@jsverse/transloco-validator": "7.0.1",
    "@ls-lint/ls-lint": "2.2.3",
    "@ngneat/spectator": "19.6.2",
    "@ngxs/devtools-plugin": "19.0.0",
    "@sentry/cli": "2.42.3",
    "@storybook/addon-essentials": "8.6.7",
    "@storybook/addon-interactions": "8.6.7",
    "@storybook/angular": "8.6.7",
    "@trivago/prettier-plugin-sort-imports": "5.2.2",
    "@types/big.js": "6.2.2",
    "@types/chart.js": "2.9.41",
    "@types/diff-match-patch": "1.0.36",
    "@types/file-saver": "2.0.7",
    "@types/fs-extra": "11.0.4",
    "@types/google.maps": "3.58.1",
    "@types/gtag.js": "0.0.20",
    "@types/intro.js": "5.1.5",
    "@types/jest": "29.5.14",
    "@types/lodash": "4.17.16",
    "@types/node": "22.13.10",
    "@types/uuid": "10.0.0",
    "angular-eslint": "19.2.1",
    "bitbucket": "2.12.0",
    "cypress": "14.2.0",
    "cypress-file-upload": "5.0.8",
    "cypress-grep": "3.0.4",
    "cypress-pipe": "2.0.0",
    "esbuild-visualizer": "0.7.0",
    "eslint": "9.22.0",
    "eslint-config-prettier": "10.1.1",
    "eslint-plugin-prettier": "5.2.3",
    "eslint-plugin-storybook": "0.11.6",
    "faker": "6.6.6",
    "flexbox-grid-mixins": "0.3.4",
    "fs-extra": "11.3.0",
    "htmlhint": "1.1.4",
    "husky": "9.1.7",
    "jest": "29.7.0",
    "jest-preset-angular": "14.6.0",
    "jira-prepare-commit-msg": "1.7.2",
    "jszip": "3.10.1",
    "less": "4.2.2",
    "lint-staged": "15.5.0",
    "lockfile-lint": "4.14.0",
    "markdownlint-cli": "0.44.0",
    "next-standard-version": "3.0.18",
    "ng-openapi-gen": "0.52.0",
    "ng-packagr": "19.2.0",
    "npm-check-updates": "17.1.15",
    "npm-package-json-lint": "8.0.0",
    "npm-package-json-lint-config-default": "7.0.1",
    "npm-run-all": "4.1.5",
    "prettier": "3.5.3",
    "prettier-plugin-multiline-arrays": "4.0.2",
    "prettier-plugin-organize-attributes": "1.0.0",
    "request": "2.88.2",
    "request-promise": "4.2.6",
    "standard-version": "9.5.0",
    "storybook": "8.6.7",
    "stylelint": "16.15.0",
    "stylelint-config-standard-scss": "14.0.0",
    "stylelint-prettier": "5.0.3",
    "svgo": "3.3.2",
    "ts-node": "10.9.2",
    "typescript": "5.8.2",
    "typescript-eslint": "8.26.1",
    "vite-bundle-visualizer": "1.2.1"
  },
  "eslintConfig": {
    "extends": [
      "plugin:storybook/recommended"
    ]
  }
}
